import compose from "./reduxDevtools";
import middlewares from "./middlewares";

export default compose(middlewares);
